import React from 'react';

import { DefaultProps } from './types';
import { MondialRelayPoint } from 'types/Cart';

export default function MondialRelayAddress({
  address,
}: DefaultProps<MondialRelayPoint>): JSX.Element {
  return (
    <>
      <p>{address.name}</p>
      <p>{address.street.join(' ')}</p>
      <p>{`${address.postalCode} ${address.city}`}</p>
    </>
  );
}
